export { default as Img200 } from './processed/200/Gentleman-Jack-S1.jpg';
export { default as Img400 } from './processed/400/Gentleman-Jack-S1.jpg';
export { default as Imgthumb } from './processed/thumb/Gentleman-Jack-S1.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Gentleman-Jack-S1.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Gentleman-Jack-S1.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      110,
      57,
      44
    ],
    "_population": 16,
    "_hsl": [
      0.03282828282828283,
      0.42857142857142855,
      0.3019607843137255
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      97,
      60,
      44
    ],
    "_population": 17,
    "_hsl": [
      0.05031446540880504,
      0.37588652482269497,
      0.27647058823529413
    ]
  },
  "Muted": {
    "_rgb": [
      161,
      108,
      92
    ],
    "_population": 661,
    "_hsl": [
      0.03864734299516908,
      0.2727272727272727,
      0.49607843137254903
    ]
  },
  "LightMuted": {
    "_rgb": [
      193,
      147,
      132
    ],
    "_population": 775,
    "_hsl": [
      0.04098360655737699,
      0.32972972972972964,
      0.6372549019607843
    ]
  },
  "DarkMuted": {
    "_rgb": [
      78,
      44,
      38
    ],
    "_population": 258,
    "_hsl": [
      0.024999999999999994,
      0.3448275862068966,
      0.2274509803921569
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Gentleman-Jack-S1.js